<template>
  
  <v-container fluid grid-list-xl>
    
    


    <v-layout row wrap>
      
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card color="green" icon="mdi-cash" title="总收入金额" :value="'￥' + Number(infoData.balance).toFixed(2)"
          sub-icon="mdi-calendar" :sub-text="`用户:${infoData.username}`" />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card color="info" icon="mdi-angular" title="已提现金额" :value="'￥' + Number(infoData.cash).toFixed(2)"
          sub-icon="mdi-calendar"  :sub-text="`用户:${infoData.username}`" />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card color="orange" icon="mdi-apple-icloud" title="待提现金额" :value="'￥' + Number(infoData.balance - infoData.cash).toFixed(2)"
          sub-icon="mdi-calendar"  :sub-text="`用户:${infoData.username}`"/>
      </v-flex>

      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card v-for="(CT,index ) in CanTing" :key="index" color="green" icon="mdi-cash" title="总收入金额" 
        :value="'￥' + Number(CT.dl_balance).toFixed(2)"  sub-icon="mdi-calendar" :sub-text="`餐厅:${CT.server_name}`" />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card  v-for="(CT,index ) in CanTing" :key="index" color="info" icon="mdi-angular" title="已提现金额" 
        :value="'￥' + Number(CT.dl_cash).toFixed(2)"  sub-icon="mdi-calendar"  :sub-text="`餐厅:${CT.server_name}`" />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card  v-for="(CT,index ) in CanTing" :key="index" color="orange" icon="mdi-apple-icloud" title="待提现金额" 
        :value="'￥' + Number(CT.dl_balance -CT.dl_cash).toFixed(2)"  sub-icon="mdi-calendar"  :sub-text="`餐厅:${CT.server_name}`"/>
      </v-flex>




      <v-flex md3 lg2>
        <v-text-field v-model="query.phone" label="手机号" class="pr-2" v-on:keyup.enter="getList()"></v-text-field>
      </v-flex>


      <v-flex md3 lg2>
        <v-select v-model="query.is_end"
          :items="[{ label: '全部状态', value: '' }, { label: '已完成', value: true }, { label: '未完成', value: false }]"
          label="审核状态" item-text="label" item-value="value" @change="getList()"></v-select>
      </v-flex>
      <v-flex md3 lg2>
        <div>
          <v-select v-model="query.pageSize" :items="pageSizes" item-text="label" @change="getList()" item-value="value"
            label="每页条数" class="pr-2 inline-block" required></v-select>
        </div>
      </v-flex>

      <v-flex xs-12 md-12 lg-12 sm-12>
        <v-btn color="gray" @click="resetSearch()">重置</v-btn>
        <v-btn color="dark" @click="getList()">
          <v-icon size="14">mdi-account-search</v-icon>&nbsp;搜索
        </v-btn>
      </v-flex>

    </v-layout>

    <v-divider></v-divider>

    <v-layout wrap justify-space-between>


    </v-layout>

    <v-layout row wrap>
      <v-flex xs-12 md-12 lg-12 sm-12>
        <el-table ref="multipleTable" :data="items" tooltip-effect="dark" style="width: 100%" border v-loading="tableLoad"
          @selection-change="handleSelectionChange">

          <el-table-column label="店长姓名" prop="name"></el-table-column>
          <el-table-column label="联系电话" prop="phone"></el-table-column>




          <el-table-column label="金额">
            <template slot-scope="scope">
              <div>￥{{ Number(scope.row.num).toFixed(2) }}</div>
            </template>
          </el-table-column>

          <el-table-column label="提现码">
            <template slot-scope="scope">

              <v-img max-height="100" @click="showPic(scope.row.cashcode)" max-width="100" :src="scope.row.cashcode" />

            </template>
          </el-table-column>

          <el-table-column prop label="提现类型">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.state == 1">商家</div>
                <div v-if="scope.row.state == 0">代理</div>
                <div v-if="scope.row.state == 3">餐厅</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop label="审核状态">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.is_end == true">已完成</div>
                <div v-if="scope.row.is_end == false">未完成</div>

              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="_createTime"></el-table-column>
          <el-table-column label="操作" v-if="userRole == 'admin'">

            <template slot-scope="scope">

              <v-btn small slot="activator" v-if="scope.row.is_end == false" color="success" @click="confirmOrder(scope.row)">
                完成
              </v-btn>


            </template>
          </el-table-column>
        </el-table>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-end mt-3>
      <el-pagination @current-change="handleCurrentChange" :current-page="query.currentPage" :page-size="query.pageSize"
        layout="total,  prev, pager, next, jumper" :total="total"></el-pagination>
    </v-layout>

  </v-container>
</template>
<script>
// import detail from './OrderDetail'
// import Authority from './Authority'
let _this;
export default {


  props: {
    load: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    load(val) {
      if (val) {
        this.pageLoad = val
      }
    },
    pageLoad(val) {
      if (val) {
        this.getList();
      }
    }
  },
  data() {
    return {
      infoData:{},
      CanTing:[],
      pageLoad: false,
      userRole:sessionStorage.getItem('role'),
      items: [],
      query: {
        phone: '',
        is_end: '',
        currentPage: 1,
        pageSize: 10
      },
      multipleSelection: [],
      pageSizes: this.$pageSizes,
      tableLoad: false,
      total: 0,
    };
  },
  mounted() {
    _this = this;
    this.getMyInfo()
    this.getList();
    this.getCanTingList();
    
  },
  methods: {
    //获取列表
  async getMyInfo(){
    const res = await this.$post('admin/getDlList', {_id:sessionStorage.getItem('uid')})
     this.infoData = res.data.data[0]
    },
    async getList() {
      this.tableLoad = true;
      const res = await this.$post('admin/getCashList', this.query)
      _this.tableLoad = false;
      if (res.errno === 0) {
        for (let i in res.data.data) {
          res.data.data[i]._createTime = this.$time(res.data.data[i]._createTime)
        }
        _this.items = res.data.data;
        _this.total = res.data.count;
      }

    },
    async getCanTingList(){
       const res= await this.$post('alipay/getCanTing');
       this.CanTing=res.data;
    },
    async confirmOrder(e) {

      this.$confirm(`用户${e.phone},是否完成当前提现申请?`).then(async r => {
        if (r == 'confirm') {
       const res =   await this.$post('admin/confirmCash', e)
         this.$message({
              message: res.errmsg,
              type: "success"
            });
         await this.getList() 
        }
      })

    },
    showPic(e){
    window.open(e,'_blank')
    },
    //重置搜索
    resetSearch() {
      this.query.orderNum = '';
      this.query.status = '';
      this.getList();
    },

    //选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    //获取id
    getIds() {
      let arr = [];
      for (let i in this.multipleSelection) {
        arr.push(this.multipleSelection[i].id)
      }
      return arr
    },

    //跳转页码
    handleCurrentChange(val) {
      this.query.currentPage = val;
      this.getList();
    },


    //更新值
    changeMsg(e) {
      this.getList()
    }

  }
};
</script>
    